module.exports = [{
      plugin: require('/zeit/7f6a684/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1280},
    },{
      plugin: require('/zeit/7f6a684/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
